import React, { FC, useState } from 'react';
import IncidentExclusionContext from './incidentExclusionContext';
import ExclusionFormDrawer from '././ExclusionsForm/ExclusionFormDrawer';
import ExclusionsTable from './ExclusionsTable/ExclusionsTable';

import { IncidentsConfiguration } from '../types';

interface Props {
    incidentConfiguration: IncidentsConfiguration;
}

const IncidentExclusions: FC<Props> = ({ incidentConfiguration }) => {
    const [isCreateExclusionFormOpen, setIsCreateExclusionFormOpen] = useState(false);
    const { selectedExclusion, setSelectedExclusion } = React.useContext(IncidentExclusionContext);

    return (
        <div className="h-full w-full flex">
            <div className="w-full flex flex-col border border-gray-200 rounded-lg gap-4 p-6">
                <div className="flex flex-col gap-4 w-full h-full">
                    <ExclusionsTable setIsCreateExclusionFormOpen={setIsCreateExclusionFormOpen} />
                </div>

                {(isCreateExclusionFormOpen || selectedExclusion) && (
                    <ExclusionFormDrawer
                        isOpen={!!selectedExclusion || isCreateExclusionFormOpen}
                        onClose={() => {
                            setIsCreateExclusionFormOpen(false);
                            setSelectedExclusion(undefined);
                        }}
                        exclusionData={selectedExclusion}
                        incidentKind={incidentConfiguration.kindLabel}
                    />
                )}
            </div>
        </div>
    );
};

export default IncidentExclusions;
